module.exports = __webpack_public_path__ + "static/img/shui4.2cdcda2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistics/shui4.png
// module id = Bceq
// module chunks = 44